import a from "../constants/screen.js";
const m = {
  screen: {
    type: String,
    default: a.small.name,
    validator: (e) => [a.small.name, a.medium.name, a.large.name].includes(e)
  }
}, r = (e) => e === a.large.name, l = (e) => e === a.large.name, s = (e) => e === a.small.name;
export {
  r as isScreenLarge,
  l as isScreenMedium,
  s as isScreenSmall,
  m as screenProp
};
